const Mispari = (state = {
  confirmationMispariMessage: '',
  mispariMessage: '',
  mispari: {
    activationCode: '',
    phoneNumber: '',
    isActiveNow: false,
    hasFutureMispari: false,
    forward: {
      number: '',
      startingDate: '',
      stoppingDate: '',
    },
  },
}, action) => {
  switch (action.type) {
    case 'SET_MISPARI':
      return {
        ...state,
        mispari: action.mispari,
      };
      case 'SET_MISPARI_MESSAGE':
        return {
          ...state,
          mispariMessage: action.mispariMessage,
        };
      case 'SET_CONFIRMATION_MISPARI_MESSAGE':
        return {
          ...state,
          confirmationMispariMessage: action.confirmationMispariMessage,
        }
    default:
      return state;
  }
};

export default Mispari;



// WEBPACK FOOTER //
// ./src/reducers/MispariReducer.js